import type { LinkToCoachingSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-coaching';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LinkToCoaching: TemplateOnlyComponent<LinkToCoachingSignature> =
  <template>
    <a href="#" ...attributes>{{yield}}</a>
  </template>;

export { LinkToCoaching };
